$(document).ready(function() {
 jQuery(".b2b-slider").owlCarousel({
 autoplay: false,
 lazyLoad: true,
 loop: false,
 margin: 10,
 slideBy: 1,
 /*
 animateOut: 'fadeOut',
 animateIn: 'fadeIn',
 */
 responsiveClass: true,
 autoHeight: true,
 nav: true,
 navText : ['<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24"><path d="M16.736 3.417a.652.652 0 0 1-.176.449l-8.32 8.301 8.32 8.301c.117.13.176.28.176.449s-.059.319-.176.449a.91.91 0 0 1-.215.127c-.078.032-.156.049-.234.049s-.156-.017-.234-.049a.93.93 0 0 1-.215-.127l-8.75-8.75a.652.652 0 0 1-.176-.449c0-.169.059-.319.176-.449l8.75-8.75a.652.652 0 0 1 .449-.176c.169 0 .319.059.449.176.117.13.176.28.176.449z"></path></svg>','<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24"><path d="M6.708 20.917c0-.169.059-.319.176-.449l8.32-8.301-8.32-8.301a.652.652 0 0 1-.176-.449c0-.169.059-.319.176-.449a.65.65 0 0 1 .449-.176c.169 0 .318.059.449.176l8.75 8.75c.117.13.176.28.176.449a.652.652 0 0 1-.176.449l-8.75 8.75a.91.91 0 0 1-.215.127c-.078.032-.156.049-.234.049s-.156-.017-.234-.049a.91.91 0 0 1-.215-.127.652.652 0 0 1-.176-.449z"></path></svg>'],
margin: 15,
 dots: false,
 responsive: {
 0: {
 items:1
 },

 600: {
 items: 2
 },

 1024: {
 items: 4
 },

 1366: {
 items:4
 }
 }
});
 jQuery(".client-slider").owlCarousel({
 autoplay: false,
 lazyLoad: true,
 loop: false,
 margin: 10,
 slideBy: 1,
 /*
 animateOut: 'fadeOut',
 animateIn: 'fadeIn',
 */
 responsiveClass: true,
 autoHeight: true,
 nav: false,
margin: 15,
 dots: false,
 responsive: {
 0: {
 items:1
 },

 600: {
 items: 2
 },

 1024: {
 items: 3
 },

 1366: {
 items:3
 }
 }
});
  });
$(document).ready(function() {
   var rellax = new Rellax('.rellax', {
            center: true,
            wrapper: document.querySelector('.Layout__main') // or '.Layout__main'
        });
});
$(document).ready(function() {
	$('.page-header a[href^="#"]').on('click',function (e) {
	    e.preventDefault();
	    var target = this.hash;
	    var $target = $(target);
	    $('html, body').stop().animate({
	        'scrollTop': $target.offset().top - 120
	    }, 1200, 'swing', function () {
	        // window.location.hash = target;
	    });
	});
});

$(window).scroll(function() {
		var scrollDistance = $(window).scrollTop();

		// Show/hide menu on scroll
		//if (scrollDistance >= 850) {
		//		$('nav').fadeIn("fast");
		//} else {
		//		$('nav').fadeOut("fast");
		//}
	
		// Assign active class to nav links while scolling
		$('.link-class').each(function(i) {
				if ($(this).position().top - 200 <= scrollDistance) {
						$('.page-header a.active').removeClass('active');
						$('.page-header a').eq(i).addClass('active');
				}
		});
}).scroll();